import Vuex from 'vuex';
import StateApp from '../store/StateApp';
import StateModal from '../store/StateModal';


const store = new Vuex.Store({
    modules: {
        app: StateApp,
        modal: StateModal,
    },
});

window.store = store;
export default store;
